<template>
  <div
    v-if="item.variants?.length"
    class="space-y-2"
  >
    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Opciones</label>
    
    <!-- Base item option - only show if base price > 0 -->
    <div
      v-if="item.price && item.price > 0"
      class="flex items-center p-3 border rounded-lg cursor-pointer transition-colors"
      :class="!selectedVariant ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-900/20' : 'border-gray-300 dark:border-gray-700'"
      @click="$emit('select-variant', null)"
    >
      <div class="flex-1">
        <p class="font-medium text-gray-900 dark:text-gray-100">
          Artículo base
        </p>
        <div class="flex items-center gap-2">
          <!-- Show original price if there's a discount -->
          <p
            v-if="item.discount_price && item.discount_price > 0"
            class="text-sm text-gray-500 dark:text-gray-400 line-through"
          >
            ${{ (item.price || 0).toFixed(2) }}
          </p>
          <!-- Show effective price -->
          <p
            class="text-sm"
            :class="item.discount_price && item.discount_price > 0 ? 'text-green-600 dark:text-green-400 font-semibold' : 'text-gray-600 dark:text-gray-400'"
          >
            ${{ (item.discount_price && item.discount_price > 0 ? item.discount_price : item.price || 0).toFixed(2) }}
          </p>
          <!-- Show discount badge -->
          <span
            v-if="item.discount_price && item.discount_price > 0"
            class="inline-flex items-center rounded-full bg-green-100 dark:bg-green-900/30 px-1.5 py-0.5 text-xs font-medium text-green-800 dark:text-green-200"
          >
            Oferta
          </span>
        </div>
      </div>
      <div
        class="w-5 h-5 rounded-full border-2 flex items-center justify-center"
        :class="!selectedVariant ? 'border-indigo-600 bg-indigo-600' : 'border-gray-300 dark:border-gray-600'"
      >
        <div
          v-if="!selectedVariant"
          class="w-2 h-2 rounded-full bg-white"
        />
      </div>
    </div>

    <!-- Variant options -->
    <div
      v-for="variant in item.variants"
      :key="variant.id"
      class="flex items-center p-3 border rounded-lg cursor-pointer transition-colors"
      :class="selectedVariant?.id === variant.id ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-900/20' : 'border-gray-300 dark:border-gray-700'"
      @click="$emit('select-variant', variant)"
    >
      <div class="flex-1">
        <p class="font-medium text-gray-900 dark:text-gray-100">
          {{ variant.name }}
        </p>
        <div class="flex items-center gap-2">
          <!-- Show original price if there's a discount -->
          <p
            v-if="variant.discount_price && variant.discount_price > 0"
            class="text-sm text-gray-500 dark:text-gray-400 line-through"
          >
            ${{ (variant.price || 0).toFixed(2) }}
          </p>
          <!-- Show effective price -->
          <p
            class="text-sm"
            :class="variant.discount_price && variant.discount_price > 0 ? 'text-green-600 dark:text-green-400 font-semibold' : 'text-gray-600 dark:text-gray-400'"
          >
            ${{ getVariantPrice(variant).toFixed(2) }}
          </p>
          <!-- Show discount badge -->
          <span
            v-if="variant.discount_price && variant.discount_price > 0"
            class="inline-flex items-center rounded-full bg-green-100 dark:bg-green-900/30 px-1.5 py-0.5 text-xs font-medium text-green-800 dark:text-green-200"
          >
            Oferta
          </span>
        </div>
      </div>
      <div
        class="w-5 h-5 rounded-full border-2 flex items-center justify-center"
        :class="selectedVariant?.id === variant.id ? 'border-indigo-600 bg-indigo-600' : 'border-gray-300 dark:border-gray-600'"
      >
        <div
          v-if="selectedVariant?.id === variant.id"
          class="w-2 h-2 rounded-full bg-white"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ExtendedMenuItem, MenuItemVariant } from '@/types/order';

interface Props {
  item: ExtendedMenuItem;
  selectedVariant: MenuItemVariant | null;
  getVariantPrice: (variant: MenuItemVariant) => number;
}

defineProps<Props>();

defineEmits<{
  'select-variant': [variant: MenuItemVariant | null];
}>();
</script>
